import React, { Component } from 'react';
import { connect } from "react-redux";
import SettingsHeader from "../SettingsHeader";
import Accordion from "../../Accordion";
import WelcomeSettings from "./chatWidget/WelcomeSettings";
import QueueSettings from "./chatWidget/QueueSettings";
import OperatorNotFoundSettings from "./chatWidget/OperatorNotFoundSettings";
import { toast } from 'react-toastify';
import {changeSetting} from "../../../actions/actions";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Language extends Component {

    constructor(props) {
        super(props);
        this.saveForm=this.saveForm.bind(this);
        this.setOperatorNotFoundMessage=this.setOperatorNotFoundMessage.bind(this);
        this.setQueuedMessage=this.setQueuedMessage.bind(this);
        this.setTopBar=this.setTopBar.bind(this);
        this.setWelcomeMessage=this.setWelcomeMessage.bind(this);
        this.setMessagePlaceholder=this.setMessagePlaceholder.bind(this);
        this.state = {
            operatorNotFoundMessage: this.props.chatprop.settings.operator_not_found_message,
            queuedMessage: this.props.chatprop.settings.queued_message,
            topBar: this.props.chatprop.settings.topbar_message,
            welcomeMessage: this.props.chatprop.settings.welcome_message,
            messagePlaceholder: this.props.chatprop.settings.message_placeholder,

        };
    }

    componentDidMount() {

    }
    saveForm(){
            var operatorNotFoundMessage=this.state.operatorNotFoundMessage.trim();
            var queuedMessage=this.state.queuedMessage.trim();
            var topBar=this.state.topBar.trim();
            var welcomeMessage=this.state.welcomeMessage.trim();
            var messagePlaceholder=this.state.messagePlaceholder.trim();

            if(operatorNotFoundMessage=="" || operatorNotFoundMessage.length<1){
                toast.error("All fields are required.");
                return false;
            }
            if(queuedMessage=="" || queuedMessage.length<1){
                toast.error("All fields are required.");
                return false;
            }
            if(topBar=="" || topBar.length<1){
                toast.error("All fields are required.");
                return false;
            }
            if(welcomeMessage=="" || welcomeMessage.length<1){
                toast.error("All fields are required.");
                return false;
            }
            if(messagePlaceholder=="" || messagePlaceholder.length<1){
                toast.error("All fields are required.");
                return false;
            }

        this.props.dispatch(changeSetting({
            topbar_message:topBar,
            welcome_message:welcomeMessage,
            message_placeholder:messagePlaceholder,
            queued_message:queuedMessage,
            operator_not_found_message:operatorNotFoundMessage,
        }));

    }
    setTopBar(e){

        this.setState({
            topBar: e.target.value
        });


    }
    setWelcomeMessage(e){

        this.setState({
            welcomeMessage: e.target.value
        });


    }
    setMessagePlaceholder(e){

        this.setState({
            messagePlaceholder: e.target.value
        });


    }

    setQueuedMessage(e){

        this.setState({
            queuedMessage: e.target.value
        });


    }
    setOperatorNotFoundMessage(e){

        this.setState({
            operatorNotFoundMessage: e.target.value
        });


    }
    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <SettingsHeader title="Customize phrases"/>
                <div className="settings-center-wrap language-center-wrap">
                    <Accordion title="Welcome your customers" clicked={true} icon="bx bx-customize" components={WelcomeSettings} setTopBar={this.setTopBar} setWelcomeMessage={this.setWelcomeMessage} setMessagePlaceholder={this.setMessagePlaceholder} topBar={this.state.topBar} welcomeMessage={this.state.welcomeMessage} messagePlaceholder={this.state.messagePlaceholder}/>
                    <Accordion title="When customer gets in a queue" clicked={false} icon="bx bx-customize" components={QueueSettings} queuedMessage={this.state.queuedMessage} setQueuedMessage={this.setQueuedMessage}/>
                    <Accordion title="When your team is away" clicked={false} operatorNotFoundMessage={this.state.operatorNotFoundMessage} setOperatorNotFoundMessage={this.setOperatorNotFoundMessage} icon="bx bx-customize" components={OperatorNotFoundSettings}/>

                    <div className="swal2-container swal2-center swal2-backdrop-show">
                        <div style={{display: "grid"}} aria-modal="true" aria-live="assertive" role="dialog"
                             aria-describedby="swal2-html-container" aria-labelledby="swal2-title"
                             className="swal2-popup swal2-modal swal2-show">
                            <div className="swal2-actions">
                                <button onClick={() => this.saveForm()} type="button"
                                        className={"swal2-confirm swal2-styled "}
                                        style={{display: "inline-block"}}>
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Language;
